const newsMainWrap = () => import("@/views/main_wrap.vue");

const createNewsViewRoute = ({ path, name, component, aliases = [], meta = {} }) => ({
    path,
    name,
    alias: aliases,
    meta,
    component: newsMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const newsRoutes = [
    createNewsViewRoute({
        path: "/news/press-releases",
        name: "Gsrne01",
        aliases: ["/gsrne01", "/news/gsrne01"],
        component: () => import("@/views/news/01/gsrne01.vue")
    }),
    createNewsViewRoute({
        path: "/news/press-releases/detail",
        name: "Gsrne0101",
        aliases: ["/gsrne0101", "/news/gsrne0101"],
        meta: {
            queryRules: {
                prrSeqno: { required: true, pattern: /^\d+$/ }
            }
        },
        component: () => import("@/views/news/01/gsrne0101.vue")
    }),
    createNewsViewRoute({
        path: "/news/newsroom",
        name: "Gsrne02",
        aliases: ["/gsrne02", "/news/gsrne02"],
        component: () => import("@/views/news/02/gsrne02.vue")
    }),
    createNewsViewRoute({
        path: "/news/story",
        name: "Gsrne03",
        aliases: ["/gsrne03", "/news/gsrne03"],
        component: () => import("@/views/news/03/gsrne03.vue")
    }),
    createNewsViewRoute({
        path: "/news/story/detail",
        name: "Gsrne0301",
        aliases: ["/gsrne0301", "/news/gsrne0301"],
        meta: {
            queryRules: {
                fctbSeqno: { required: true, pattern: /^\d+$/ }
            }
        },
        component: () => import("@/views/news/03/gsrne0301.vue")
    }),
];
